module.exports = __webpack_public_path__ + "img/logo-top.c4198787.svg";